import {vnTemplate} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import {imageWidget_template} from './imageWidget_template';
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import {DragAndDropHandler} from '../../utils/DragAndDropHandler';
import {filterAutocomplete_template} from './filterAutocomplete_template';

declare var ko: any;

export class discountCategorySponsorship_template extends vnTemplate {

    public sponsorImage: imageWidget_template;
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;
    public discountFilter: filterAutocomplete_template;

    protected initPartial() {
        this.imagePicker = new imagePicker_template('imagePicker', this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );
        this.sponsorImage = new imageWidget_template('sponsor_image', this.getTemplateViewModel(), this.caller);
        this.sponsorImage.setMode('single-select');
        this.sponsorImage.setCaller(this.imagePickerHelper);
        this.discountFilter = new filterAutocomplete_template('filter_categoryDiscounts', this.getTemplateViewModel(), this.caller);
        this.discountFilter.setAddNewOptionEnabled(false);
        this.discountFilter.setNumberOfChars(1);
        this.discountFilter.setHasDisplayNameComplement(true);
        this.discountFilter.setPlaceholderAndLabel('An Assigned Discount');
    }

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="w-list-results" id="list-results" data-bind="visible: !id()">
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span>Category</span></th>
                            <th><span>Slug</span></th>
                            <th><span>Sponsorship</span></th>
                            <th><span>Edit</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: categories">
                        <tr>
                            <td data-bind="text: $data.name"></td>
                            <td data-bind="text: $data.slug"></td>
                            <td data-bind="text: $data.sponsorUrl ? 'Configured' : 'Not configured'"></td>
                            <td><button class="btn border only-icon icon i-edit" type="button" title="Edit Configuration" data-bind="event: { click: $parent.onEditCategory }"><span class="hidden-text">Edit Configuration</span></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="w-form" data-bind="visible: id">
                <div class="form-header">
                    <h3 class="form-title">Discount Category Configuration</h3>
                </div>
                <div class="form-body">
                    <div class="form-group">
                        <button class="btn secondary" type="button" data-bind="event: { click: onBackToCategories }">Back to Categories</button>
                    </div>
                    <h3 class="form-sub-title">Sponsorship</h3>
                    <div class="form-group">
                        <label class="form-label">Sponsor Logo</label>
                        ${this.sponsorImage.getHtmlBuild()}
                    </div>
                    <div class="form-group">
                        <label class="form-label">Sponsor URL</label>
                        <input class="input-text" type="url" pattern="https://.*" data-bind="value: sponsorUrl" placeholder="https://...">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Tracking Pixels (JSON format)</label>
                        <textarea data-bind="value: trackingPixelsJson" class="input-text" rows="8" placeholder='[{"type": "image", "url": "https://..."}]'></textarea>
                    </div>

                    <h3 class="form-sub-title">Pinned Discounts</h3>
                    <div class="form-group">
                        <p class="form-text mlt-discount-category-pinned-help">Add discounts assigned to this category, then drag to set their ranked order.</p>
                        <div class="w-pinned mlt-discount-pinned mlt-discount-category-pinned">
                            <div class="pinned-form">
                                ${this.discountFilter.getHtmlBuild()}
                                <div class="right">
                                    <button class="btn secondary" type="button" data-bind="event: { click: onAddDiscount }">Add to Position <span data-bind="text: pinnedDiscounts().length + 1"></span></button>
                                </div>
                            </div>
                            <div class="form-body" data-bind="foreach: pinnedDiscounts, childrenComplete: handleDragAndDrop($element, pinnedDiscounts, '.entry')">
                                <div class="pinned-form article-pinned entry">
                                    <div class="pinned-drag icon i-drag">
                                        <span class="pinned-position" data-bind="text: $index() + 1"></span>
                                    </div>
                                    <div class="w-btn">
                                        <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onDeleteDiscount }"><span class="hidden-text">Delete</span></button>
                                    </div>
                                    <div class="w-title">
                                        <span class="pinned-title" data-bind="text: name"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="form-text" data-bind="visible: pinnedDiscounts().length === 0">There are no pinned discounts in this category.</p>
                    </div>
                    <p class="form-text mlt-discount-category-save-status" data-bind="visible: saveStatus, text: saveStatus"></p>
                </div>
                <div class="form-footer">
                    <button class="btn highlight" data-bind="event: { click: onSave }" type="button">Save Category Configuration</button>
                </div>
            </div>
            ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected getTemplateName(): string {
        return 'discountCategorySponsorship_template';
    }

    protected getMainElementClasses(): string[] {
        return ['w-content'];
    }

    protected buildViewModel(): any {
        const self = this;

        return {
            categories: ko.observableArray([]),
            id: ko.observable(),
            idSponsorImage: ko.observable(),
            sponsorUrl: ko.observable(''),
            trackingPixelsJson: ko.observable(''),
            availableDiscounts: ko.observableArray([]),
            pinnedDiscounts: ko.observableArray([]),
            saveStatus: ko.observable(''),
            onEditCategory: (category) => self.caller.editCategory(category.id),
            onBackToCategories: () => self.caller.showCategories(),
            onAddDiscount: () => self.addDiscount(),
            onDeleteDiscount: (discount) => self.deleteDiscount(discount),
            handleDragAndDrop: (element, items, selector) => DragAndDropHandler.handleDragAndDrop(element, items, selector),
            onSave: () => self.caller.save()
        };
    }

    public setCategories(categories: any[]): void {
        this.getTemplateViewModel().categories(categories || []);
    }

    public setCategoryId(id: number): void {
        this.getTemplateViewModel().id(id);
    }

    public clearCategory(): void {
        const viewModel = this.getTemplateViewModel();
        viewModel.saveStatus('');
        viewModel.idSponsorImage(null);
        viewModel.sponsorUrl('');
        viewModel.trackingPixelsJson('');
        viewModel.availableDiscounts([]);
        viewModel.pinnedDiscounts([]);
        this.discountFilter.clearInputNoCallback();
        this.sponsorImage.clearImage();
    }

    public setCategoryConfiguration(data: any): void {
        const viewModel = this.getTemplateViewModel();
        const category = data.category || {};
        const discounts = data.discounts || [];

        viewModel.idSponsorImage(category.idSponsorImage || null);
        viewModel.sponsorUrl(category.sponsorUrl || '');
        viewModel.trackingPixelsJson(category.trackingPixels ? JSON.stringify(category.trackingPixels, null, 2) : '');
        viewModel.availableDiscounts(discounts);
        viewModel.pinnedDiscounts(discounts.filter(d => d.pinnedPosition).sort((a, b) => a.pinnedPosition - b.pinnedPosition));
        this.discountFilter.clearInputNoCallback();

        if (category.sponsorImage) {
            this.sponsorImage.setImage(category.sponsorImage);
        } else {
            this.sponsorImage.clearImage();
        }
    }

    public setSaveStatus(message: string): void {
        this.getTemplateViewModel().saveStatus(message);
    }

    public setDiscountSuggestions(discounts: any[]): void {
        this.discountFilter.setOptions(discounts);
    }

    protected addDiscount(): void {
        const viewModel = this.getTemplateViewModel();
        const discount = this.discountFilter.getOptionObj();

        if (!discount) {
            this.caller.notify('Please select an assigned discount first.');
            return;
        }
        if (viewModel.pinnedDiscounts().some(d => Number(d.id) === Number(discount.id))) {
            this.caller.notify('This discount is already pinned.');
            return;
        }

        viewModel.pinnedDiscounts.push(discount);
        this.discountFilter.clearInputNoCallback();
    }

    protected deleteDiscount(discount: any): void {
        const viewModel = this.getTemplateViewModel();
        viewModel.pinnedDiscounts(viewModel.pinnedDiscounts().filter(d => d.id !== discount.id));
    }

    public setSponsorImage(image: any): void {
        this.getTemplateViewModel().idSponsorImage(image.id);
        this.sponsorImage.setImage(image);
    }

    public removeSponsorImage(): void {
        this.getTemplateViewModel().idSponsorImage(null);
        this.sponsorImage.clearImage();
    }

    public getViewModelForRequest(): any {
        const viewModel = this.getTemplateViewModel();
        let trackingPixels = null;

        try {
            const raw = viewModel.trackingPixelsJson();
            if (raw && raw.trim()) {
                trackingPixels = JSON.parse(raw);
            }
        } catch (e) {
            // leave as null if invalid JSON
        }

        return {
            id: viewModel.id(),
            idSponsorImage: viewModel.idSponsorImage(),
            sponsorUrl: viewModel.sponsorUrl(),
            trackingPixels: trackingPixels,
            discountIds: viewModel.pinnedDiscounts().map(d => d.id)
        };
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/discountCategorySponsorship_template.ts